import { Line } from "react-chartjs-2";
import "./chartSetup";
import { gridColor } from "./chartTheme";
import type { Theme } from "../theme/ThemeProvider";

interface Point {
  hour?: string;
  period?: string;
  input?: number;
  output?: number;
}

interface Props {
  data: Point[];
  theme: Theme;
}

export function TokensChart({ data, theme }: Props) {
  return (
    <Line
      data={{
        labels: data.map((r) => r.hour ?? r.period ?? ""),
        datasets: [
          {
            label: "Input",
            data: data.map((r) => r.input ?? 0),
            borderColor: "#6DA0FF",
            backgroundColor: "rgba(109,160,255,0.08)",
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 2,
          },
          {
            label: "Output",
            data: data.map((r) => r.output ?? 0),
            borderColor: "#6C63FF",
            backgroundColor: "rgba(108,99,255,0.08)",
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 2,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { labels: { color: "#A39C91", font: { size: 11 } } },
        },
        scales: {
          x: {
            grid: { color: gridColor(theme) },
            ticks: { color: "#6A6359", font: { size: 10 } },
          },
          y: {
            grid: { color: gridColor(theme) },
            ticks: { color: "#6A6359", font: { size: 10 } },
          },
        },
      }}
    />
  );
}
